import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MonedasDto } from '../models/monedas.dto';

@Injectable({
  providedIn: 'root'
})
export class MonedasService {
  private apiUrl = ``;
  private entity = `monedas`;

  constructor(private http: HttpClient) {
    if (environment.production)
      this.apiUrl = environment.apiUrl + this.entity;
    else
      this.apiUrl = environment.apiUrlDev + this.entity;

  }


  getAll(): Observable<MonedasDto[]> {
    return this.http.get<MonedasDto[]>(this.apiUrl);
  }

}
